// extracted by mini-css-extract-plugin
module.exports = {"debugWidgetContainer":"DebugWidget_debugWidgetContainer__1No7z","debugWidgetInteractive":"DebugWidget_debugWidgetInteractive__2rsId"};